export const APPLICATION_ANALYTICS = {
  opened: 'application_opened',
  action: 'application_action',
  bulkOpened: 'applications_bulk_process_opened',
  bulkSubmitted: 'application_bulk_process_submitted'
} as const

type PosthogCapture = {
  capture: (event: string, properties?: Record<string, unknown>) => void
}

export const captureApplicationOpened = (
  posthog: PosthogCapture,
  applicationId: number
) => {
  posthog.capture(APPLICATION_ANALYTICS.opened, {
    source: 'react',
    applicationId
  })
}

export const captureBulkProcessOpened = (
  posthog: PosthogCapture,
  action: string,
  applicationsCount: number
) => {
  posthog.capture(APPLICATION_ANALYTICS.bulkOpened, {
    source: 'react',
    action,
    applicationsCount
  })
}

export const captureBulkProcessSubmitted = (
  posthog: PosthogCapture,
  action: string,
  applicationsCount: number
) => {
  posthog.capture(APPLICATION_ANALYTICS.bulkSubmitted, {
    source: 'react',
    action,
    applicationsCount
  })
}

export const captureApplicationAction = (
  posthog: PosthogCapture,
  action:
    | 'integrate_new'
    | 'link_existing'
    | 'accept'
    | 'decline'
    | 'update_field',
  properties: Record<string, unknown>
) => {
  posthog.capture(APPLICATION_ANALYTICS.action, {
    source: 'react',
    action,
    ...properties
  })
}
